export const ExposeAppConfig = ({ appConfig }) => {
    return (<script id={'app-config'} suppressHydrationWarning dangerouslySetInnerHTML={{
            __html: `window.appConfig = ${JSON.stringify(appConfig)}`,
        }}/>);
};
export default ExposeAppConfig;
